import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Thumbnail} from '@Components/thumbnail';
import {getAssetUrl} from '@Utils/s3.util';
import {getCompatibleImageFileExtension} from '@Utils/image.util';
import styles from './version-history-onboarding-popup.module.scss';
import {ThumbnailType} from '@Components/thumbnail/thumbnail.types';

interface VersionHistoryOnboardingPopupProps {
  onClose(): void;
}

export function VersionHistoryOnboardingPopup({...props}: VersionHistoryOnboardingPopupProps): ReactElement<any> {
  return (
    <div className={`_full-width _full-height radius-8 flex flex-v-row content-body border-s-standard shadow-floating-elevation-3 ${styles.container}`}>
      <div className="spacing-p-t-3 flex-align-items-center flex-row-justify-between spacing-p-l-3 spacing-p-r-3">
        <div className="flex-h-row flex-align-items-center">
          <Text size={TextSize.SMALL} bold val={window.i18next.t('pmwjs_version_history_onboarding_heading')} className="spacing-m-r-2 color-standard-text" />
        </div>
        <Icon
          onClick={(): void => {
            props.onClose();
          }}
          icon="icon-close"
          shape={IconShape.SQUARE}
          type={IconType.GHOST}
          size={IconSize.SIZE_ICON_16}
        />
      </div>
      <div className="spacing-p-4 flex-v-row _full-width _full-height">
        <Thumbnail
          className="spacing-m-b-4"
          data={{
            type: ThumbnailType.IMAGE,
            imageSrc: getAssetUrl(`version-history-onboarding-thumbnail-highres.${getCompatibleImageFileExtension('png')}`),
          }}
        />
        <Text size={TextSize.XSMALL} val={window.i18next.t('pmwjs_version_history_onboarding_text')} />
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="13" viewBox="0 0 23 13" fill="none" className={styles.arrow}>
        <path d="M15.1057 1.90637C13.5189 -0.434486 10.0703 -0.434487 8.48361 1.90637L0.963778 13.0001L22.6255 13.0001L15.1057 1.90637Z" fill="white" />
      </svg>
    </div>
  );
}
